import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { RouteService } from '../../services/route.service'
import { ROUTES } from '../../constants/routes'
import { Router, RouterModule } from '@angular/router'

import { NavbarService } from '../../services/navbar.service'
import { AuthService } from '../../services/auth.service'
@Component({
  selector: 'app-admin',
  imports: [RouterModule],
  templateUrl: './admin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './admin.component.scss',
})
export class AdminComponent implements OnInit {
  private routeService = inject(RouteService)
  private router = inject(Router)
  private authService = inject(AuthService)
  private navbarService = inject(NavbarService)

  constructor() {
    const routeService = this.routeService

    const currentRoute = routeService.getUserRoutes(
      ROUTES.VITE_MARKETPLACE.title,
      `/${ROUTES.ADMIN.path}`,
    )
    routeService.setRoute(currentRoute)
  }

  ngOnInit(): void {
    this.navbarService.showNavBar()
  }
}
